export const SCRN_LOG_IN = '/log-in';
export const SCRN_NOT_FOUND = '/not-found';
export const SCRN_DASHBOARD = '/dashboard';